import { makeStyles, shorthands } from "@fluentui/react-components";
import { BRAND } from "./tokens";

const useStyles = makeStyles({
  card: {
    width: "100%",
    maxWidth: "1024px",
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: "20px",
    paddingBottom: "20px",
    paddingLeft: "20px",
    paddingRight: "20px",
    backgroundColor: BRAND.purple,
    backgroundImage: `linear-gradient(135deg, ${BRAND.purple} 0%, #3a1c52 100%)`,
    ...shorthands.borderRadius("10px"),
    boxShadow: "0 24px 48px rgba(0,0,0,0.3)",
    fontFamily: BRAND.fontPrimary,
  },
  heading: {
    marginTop: 0,
    marginBottom: "20px",
    color: BRAND.gold,
    fontFamily: BRAND.fontAccent,
    fontWeight: 400,
    fontSize: "clamp(1.1rem, 3.6vw, 1.6rem)",
    lineHeight: 1.2,
  },
  row: {
    display: "grid",
    gap: "12px",
    gridTemplateColumns: "1fr 1fr",
    "@media (min-width: 768px)": {
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: "16px",
    },
  },
  pillar: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    color: BRAND.white,
    boxShadow: "0 6px 12px rgba(0,0,0,0.25)",
    minHeight: "180px",
    paddingTop: "20px",
    paddingBottom: "20px",
    paddingLeft: "16px",
    paddingRight: "16px",
    rowGap: "16px",
    textAlign: "center",
    ...shorthands.borderRadius("8px"),
  },
  pillarNumber: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "36px",
    height: "36px",
    fontFamily: BRAND.fontAccent,
    fontWeight: 700,
    color: BRAND.ink,
    backgroundColor: BRAND.white,
    fontSize: "1.05rem",
    boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
    ...shorthands.borderRadius("999px"),
  },
  label: {
    fontFamily: BRAND.fontPrimary,
    fontSize: "1.1rem",
    fontWeight: 700,
    lineHeight: 1.25,
  },
});

const Pillar = ({
  number,
  bg,
  title,
  styles,
}: {
  number: number;
  bg: string;
  title: string;
  styles: ReturnType<typeof useStyles>;
}) => (
  <div className={styles.pillar} style={{ backgroundColor: bg }}>
    <span className={styles.pillarNumber}>{number}</span>
    <div className={styles.label}>{title}</div>
  </div>
);

const PillarsGraphic = () => {
  const styles = useStyles();
  return (
    <div className={styles.card}>
      <h2 className={styles.heading}>
        Risiken – identifizieren, bewerten, reduzieren, absichern und optimieren (auch die
        Chancen daraus)
      </h2>
      <div className={styles.row}>
        <Pillar
          number={1}
          bg={BRAND.pillarOrange}
          title="Verlust / Beschädigung / Zerstörung von Sachwerten"
          styles={styles}
        />
        <Pillar
          number={2}
          bg={BRAND.pillarBlue}
          title="Haftung / Recht"
          styles={styles}
        />
        <Pillar
          number={3}
          bg={BRAND.pillarGreen}
          title="Menschen im Unternehmen"
          styles={styles}
        />
        <Pillar
          number={4}
          bg={BRAND.pillarBlack}
          title="Liquidität / Ertragsausfall"
          styles={styles}
        />
      </div>
    </div>
  );
};

export default PillarsGraphic;
